import { inject, Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LogInWithThirdPartySso } from '@pages/login/store/actions/log-in-with-third-party-sso.actions';

@Injectable({
  providedIn: 'root',
})
export class LogInWithThirdPartySsoFacade {
  private readonly store = inject(Store);

  logInWithThirdPartySso(samlLoginUrl: string): void {
    this.store.dispatch(new LogInWithThirdPartySso(samlLoginUrl));
  }
}
